import TRANSLATION from "./translation_config";

let etc_config = {
    TRANSLATION: TRANSLATION,
    SETTINGS: {
        INFORMATION_RESOURCE: {
            ENDPOINTS: {

            },
        }
    },

    INTERFACE_DETAIL_HELP: {
        'addinterface': [],
        'viewinterface': [],
        'editinterface': [],
        'publishinterface': [],
        'depublishinterface': [],
        'application': []
    },

    INFORMATION_RESOURCE_DETAIL_HELP: {
        'createirs': [],
        'viewirs': [],
        'editirs': [],
        'addoperator': [],
        'deleteoperator': [],
        'publishirs': [],
        'depublishirs': [],
        'application': [],
    },
};

export default etc_config;




// {
//     'title': 'Що таке інтерфейс?',
//     'content': 
//         `Інтерфейс е-ресурсу – сукупність сервісів що реалізують певний функціонал системи.`
// }, {
//     'title': 'Що таке сервіс?',
//     'content': 
//         `Метод вебсервісу – публікується на Шлюзі безпечного обміну.`
// }, {
//     'title': 'Вимоги з опису сервісів',
//     'content': 
//         `До інтерфейсу е-ресурсу повинні бути додані всі опубліковані в тестовому та промисловому 
//         середовищах сервіси, що формують повний цикл обміну даними в рамках інтерфейсу е-ресурсу. 
//         За замовчуванням, інтерфейси е-ресурсу складаються із одного сервісу (в цьому випадку у 
//             полі «Роль» має бути обрано значення «Основний»). У випадку, якщо інтерфейс е-ресурсу 
//             складається із множини сервісів, що формують процес обміну інформацією, то у полі «Роль» 
//             значення «Основний» встановлюється для сервісу, що передбачає отримання/передачу даних,
//              а всі інші сервіси в цьому випадку у полі «Роль» мають значення «Допоміжний».`
// }, {
//     'title': 'Вимоги до документації інтерфейсу',
//     'content': 
//         `Кожен інтерфейс е-ресурсу повинен бути описаний у вигляді документу «Опис 
//         програмного інтерфейсу електронного інформаційного ресурсу» відповідно до вимог 
//         Регламенту системи. Окрім цього документ можуть бути додані інші документи, які 
//         описують роботу сервісів, що формують інтерфейс е-ресурсу. Всі документи повинні 
//         містити актуальний опис.`
// }, {
//     'title': 'Які документи додавати до заявки?',
//     'content': 
//         `- Інструкція користувача вебсервісу<br>
//         - Версії сервісу, та CHANGELOG змін<br>
//         - Нормативно правові документи.`
// }




// {
//     'title': 'Що таке інформаційний е-ресурс?',
//     'content': 
//         `Е-ресурс – інформаційна, інформаційно-комунікаційна система або публічний електронний реєстр (реєстр, кадастр, регістр), який зареєстрований в системі Трембіта`
// }, {
//     'title': 'Як отримати реєстраційний номер в НРЕІР?',
//     'content': 
//         `Метод вебсервісу – публікується на Шлюзі безпечного обміну.`
// }, {
//     'title': 'Як заповнити заявку?',
//     'content': 
//         `<b>У формі заявки вкажіть:</b><br>
//         -	найменування е-ресурсу;<br>
//         -	найменування юридичної особи – технічного адміністратора;<br>
//         -	виберіть з випадаючого списку найменування юридичної особи – оператора (операторів) (за наявності);<br>
//         -	призначення е-ресурсу;<br>
//         -	нормативно правова підстава створення е-ресурсу (за наявності);<br>
//         -	реєстраційний номер е-ресурсу в Національному реєстрі електронних інформаційних ресурсів (за наявності);<br>
//         -  дані про керівника/уповноважену особу;<br>
//         <br>
//         Після заповнення усіх обов’язкових полів форми заявки натисніть «Перейти до перегляду».<br><br>
//         ! У разі необхідності внесення змін у заповнену форму заявки  натисніть кнопку «Редагувати», а після внесення змін натиснути кнопку «Підтвердити зміни».<br><br>
//         Перегляньте заповнену форму заявки та натисніть «Підтвердити та продовжити».
//         `
// }


// {
//     'title': 'Що таке інформаційний е-ресурс?',
//     'content': 
//         `Е-ресурс – інформаційна, інформаційно-комунікаційна система або публічний електронний реєстр (реєстр, кадастр, регістр), який зареєстрований в системі Трембіта`
// },



// {
//     'title': 'Як оновити документацію інтерфейсу?',
//     'content': 
//         `Для оновлення документації, що містить опис е-ресурсу необхідно:<br>
//         -	Або вилучити старий документ і додати новий з ідентичною назвою;<br>
//         -	Або додати новий документ із зазначенням версії документу.
//         `
// },